import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_LIST_BY_STAY_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_CALENDAR_QUERY = graphql(/* GraphQL */ `
	query ReservationListByStayDateForManagementReservationSearchCalendar($hotelID: ID!, $from: String!, $to: String!) {
		reservationListByStayDate(hotelID: $hotelID, from: $from, to: $to) {
			id
			hotelID
			reservations {
				hotelID
				reservationID
				reservationType
				repeaterType
				reservationStatus
				guestName
				guestTel
				guestEmail
				guestPostalCode
				guestAddress
				checkIn
				checkInTimeStart
				checkInTimeEnd
				checkOut
				reserveDate
				latestUpdateDate
				canceledDate
				numOfPeople
				numOfAdult
				numOfKids
				numOfRoom
				plan
				planCanceled
				room {
					roomID
					name
					date
					numOfPeople {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
				}
				roomCanceled {
					roomID
					name
					date
					numOfPeople {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
				}
				option {
					optionID
					name
					date
					amount
				}
				optionCanceled {
					optionID
					name
					date
					amount
				}
				discount
				paymentMethod
				totalGuestCharge
				pricePlanTotal
				priceRoomTotal
				priceOptionTotal
				priceAdditionalFeeTotal
				priceDiscount
				isAcceptMailMagazine
			}
		}
	}
`);
